<dx-drop-down-box
  #udxFieldListDropDown
  class="flex-grow-1 np-highlight"
  style="width: 450px;"
  [showClearButton]="true"
  [(value)]="pimField.field"
  [dataSource]="fieldList"
  [displayExpr]="getFieldDisplayExpr"
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  placeholder="{{ 'Feld auswählen' | translate}}"
>
  <div *dxTemplate="let item of 'content'">
    <dx-list
      [searchEnabled]="true"
      [dataSource]="fieldList"
      searchExpr="text"
      [displayExpr]="getFieldDisplayExpr"
      valueExpr="field"
      selectionMode="single"
      (onItemClick)="onFieldItemClick($event)"
    ></dx-list>
  </div>
</dx-drop-down-box>


<dx-text-box class="flex-grow-1 np-highlight"
             label="{{ 'GRUPPE.NAME' | translate }}"
             [(value)]="pimField.systemKey"
             (onValueChanged)="onOrderChanged($event)"></dx-text-box>
